import { render, staticRenderFns } from "./Caspian.vue?vue&type=template&id=b88d54d4&scoped=true"
import script from "./Caspian.vue?vue&type=script&lang=js"
export * from "./Caspian.vue?vue&type=script&lang=js"
import style0 from "./Caspian.vue?vue&type=style&index=0&id=b88d54d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88d54d4",
  null
  
)

export default component.exports